import { getJsonLdBase } from '@utils/jsonLdHelpers';
import Head from 'next/head';
import React from 'react';
import { NewsArticleJsonLdProps } from './JsonLd.types';

export const NewsArticleJsonLd: React.FC<NewsArticleJsonLdProps> = ({
  url,
  section,
  dateCreated,
  ...props
}) => {
  const jsonLdData = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    url,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    articleSection: section,
    dateCreated,
    ...getJsonLdBase(props),
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdData) }}
      />
    </Head>
  );
};
